import React, { useState, useEffect } from 'react';
import { Spin, Button, Select, Modal, Input } from 'antd';
import { useDispatch } from 'react-redux';
import { type AppDispatch } from '../../../redux/store';
import {
  getLedgerAction,
  sendOtpDownloadAction,
  verifyOtpDownloadAction,
} from '../store/overviewActions';

export default function LedgerIndex(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();

  const [branchOptions, setBranchOptions] = useState<
    Array<{
      label: string;
      value: string;
    }>
  >([]);

  const [branch, setBranch] = useState<any>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // OTP modal states
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpLoading, setOtpLoading] = useState(false);

  useEffect(() => {
    const branches = localStorage.getItem('branches');
    if (branches != null) {
      const parsedBranches = JSON.parse(branches);
      const branchOptionTemp: Array<{ label: string; value: string }> =
        parsedBranches.map((branch: { code: string; id: string }) => ({
          label: branch.code,
          value: branch.id,
        }));
      setBranchOptions(branchOptionTemp);
      setBranch(parsedBranches[0].id);
    }
  }, []);

  const handleDownloadClick = async () => {
    setIsLoading(true);
    const res = await sendOtpDownloadAction(dispatch, { type: 'ledger' });
    setIsLoading(false);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (res) {
      setOtpModalVisible(true);
    }
  };

  const handleOtpSubmit = async () => {
    setOtpLoading(true);
    const res = await verifyOtpDownloadAction(dispatch, {
      type: 'ledger',
      otp,
    });
    setOtpLoading(false);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (res) {
      setOtpModalVisible(false);
      setOtp('');
      setIsLoading(true);
      await getLedgerAction(dispatch, { branch });
      setIsLoading(false);
    }
  };

  return (
    <div className="ledger__table__page">
      <Spin spinning={isLoading} fullscreen />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 14,
          alignItems: 'center',
        }}
      >
        <Select
          value={branch}
          onChange={(value: string): void => {
            setBranch(value);
          }}
          style={{ width: 311, height: 56 }}
          placeholder="Select branch"
          options={branchOptions}
          className="expense__input"
        />
        <Button onClick={handleDownloadClick} loading={isLoading} disabled={isLoading} className="search__button">
          <span>Download Ledger</span>
        </Button>
      </div>
      <Modal
        open={otpModalVisible}
        title="Enter OTP"
        footer={null}
        onCancel={() => {
          setOtpModalVisible(false);
          setOtp('');
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p style={{ margin: 0, textAlign: 'center', color: '#64748b' }}>
            OTP sent to the organization&apos;s ledger emails
          </p>
          <Input
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => {
              setOtp(e.target.value);
            }}
            maxLength={6}
            className="expense__input"
            style={{
              width: 176,
              height: 48,
              padding: 8,
              borderRadius: 12,
              fontWeight: 700,
            }}
          />
          <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
            <Button
              className="search__button"
              onClick={() => {
                setOtpModalVisible(false);
                setOtp('');
              }}
              style={{
                width: 176,
                height: 48,
                padding: 8,
                borderRadius: 12,
                fontWeight: 700,
              }}
            >
              Cancel
            </Button>
            <Button
              className="search__button"
              type="primary"
              loading={otpLoading}
              onClick={handleOtpSubmit}
              disabled={otp.length !== 6}
              style={{
                width: 176,
                height: 48,
                padding: 8,
                borderRadius: 12,
                backgroundColor: otp.length !== 6 ? 'white' : '#DD1E2D',
                color: otp.length !== 6 ? 'black' : 'white',
                fontWeight: 700,
                borderColor: otp.length !== 6 ? 'black' : 'white',
              }}
            >
              Verify & Download
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
